import { render, staticRenderFns } from "./CreatNewSection.vue?vue&type=template&id=735cdfe4"
import script from "./CreatNewSection.vue?vue&type=script&lang=js"
export * from "./CreatNewSection.vue?vue&type=script&lang=js"
import style0 from "./CreatNewSection.vue?vue&type=style&index=0&id=735cdfe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports